module.exports = __webpack_public_path__ + "img/02.d018cb77.png";